<script setup lang="ts">
defineProps<{
  text: string
  color?: string
}>()

const modelValue = defineModel<boolean>({ default: false })
</script>

<template>
  <v-snackbar
    v-model="modelValue"
    :color="color ?? 'success'"
  >
    {{ text }}
    <template #actions>
      <v-btn
        icon
        variant="text"
        @click="modelValue = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
